<template>
	<div class="exchange">
    <div class="exchangeHeader">
      <div></div>
      <div @click="showMeTheCode()" ></div>
      
    </div>

    <div class="exchangeContent">
      <div class="contentHeader">
        <div></div>
        <div>VIP兑换</div>
        <div></div>
      </div>

      <div class="exchangeNum">
        <input type="text" placeholder="请输入兑换码,请注意区分大小写" v-model="code">
      </div>

      <div class="exchangePhone">
        <input type="text" placeholder="请输入手机号码" v-model="account">
      </div>

      <div class="exchangeButton" @click="exchangeCfm()">立即兑换</div>
    </div>


    <div class="exchangeRule">
        <span>规则说明</span>

        <div v-for="(item,index) in ruleList" v-bind:key="index">
            {{item}}
        </div>  
    </div>


<section class="wmassageMask" v-if="writeMessageShow" @click="writeMessageFun($event)" >
　　<div class="messageMaskContent" ref="msk">
　　　　<div class="msgHeader">
        <div>兑换码状态</div>
        <i @click="writeMessageShow=false"></i>  
      </div>
      <div class="msgContent" v-if="exchangeList.length>0">
        <div>
          <span>发放时间</span>
          <span>券码</span>
          <span>状态</span>
        </div>

        <ul>
          <li v-for="(item,index) in exchangeList" v-bind:key="index">
            <span>{{item.created|changeTime}}</span>
            <span>{{item.code}}</span>
            <span>
              <span v-if="item.expire_status==1&&item.destroy_status!=1">已过期</span>
              <span v-if="item.use_status==0&&item.expire_status==0&&item.destroy_status==0">未使用</span>
              <span v-if="item.use_status==1&&item.destroy_status==0&&item.expire_status==0">已使用</span>
              <span v-if="item.destroy_status==1">已失效</span>
            </span>

          </li>
        </ul>
      </div>

      <div v-if="exchangeList.length==0">
        暂无记录
      </div>
      <div class="msgBottom" v-if="total>6">
        <div @click="getList(page-1)">上一页</div>/<div @click="getList(page+1)">下一页</div>
      </div>
　　</div>
</section>



	</div>

</template>

<script>
	import { rechargeParam,timeFormat,getUrlParam } from '../assets/js/common.js'

	export default{
		data(){
			return{
				ruleList:[
                  "1、兑换码有效期为购买套餐成功后的7天内，逾期失效。兑换成功后将自动发放优酷VIP会员到您输入的手机号码上，登录优酷视频即可查看。",
                  "2、体验月卡兑换后立即获得相应时长，有效时长结束后会员资格失效。",
                  "3、会员卡兑换后立即到账，在优酷视频登录后可直接使用。",
                  "4、若产生套餐退费的情况，兑换码未使用时可根据套餐剩余资费进行退费，退费成功后兑换码失效，兑换码已使用的情况下需根据套餐剩余资费及扣除优酷VIP会员的月卡费用20元进行退费。",
                  "5、本次活动解释权最终归深圳前海翼联科技有限公司所有。"
                  ],
        writeMessageShow: false,
        exchangeList:[],
        code:"",
        account:"",
        page:1,
        page_size:6,
        totalPage:1,
        total:0,
        currentType:1
			}
    },
    components:{

    },
		created(){
      if(getUrlParam("type")){
        this.currentType=getUrlParam("type");
      }
    },
    filters:{
      changeTime(time){
            let now = new Date(time * 1000),
            y = now.getFullYear(),
            m = now.getMonth() + 1,
            d = now.getDate();
            return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) ;
      }
    },
		methods:{
      showMeTheCode(){
        this.writeMessageShow=true
        this.getList(this.page,this.page_size)
      },
      writeMessageFun (ev) {
　　　　  if (!this.$refs.msk.contains(ev.target)) {
　　　　  　　this.writeMessageShow = false;
　　　　  }
　　    },
      exchangeCfm(){

        this.account = String(this.account).replace(/\s*/g, "");
        this.code = String(this.code).replace(/\s*/g, "");


        if(this.code==""){
          alert("请填写兑换码");
          return false;
        }
        if(this.account==""){
          alert("请填写手机号");
          return false
        }
        if(!(/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(Number(this.account)))){ 
          alert("手机号码有误，请重填");  
          return false; 
        } 
				this.$http.post("/test/v1/yk-code/exchange?"+rechargeParam({},true,false,true),{
					code:this.code,
					account:this.account
				},{emulateJSON:true}).then((response) => {
					if(response.data.error == 0){
            alert("兑换成功，优酷会员已经发放到您输入的手机号啦。");
            this.code="";
            this.account=""
				  }else if(response.data.error == "30005"){

				  }else{
				  	alert(response.data.msg);
  
				  }
				})
      },
      getList(page,page_size){
        if(page==0){
          return false;
        }
        if(page>this.totalPage){
          return false;
        }
        this.page=page;

        this.$http.get("/test/v1/yk-code/mine?" + rechargeParam({
					params: {
						page: page,
						page_size: page_size?page_size:6
					}
				}, false, false,true)).then((response) => {
					if(response.data.error == 0) {
            
            this.exchangeList=response.data.data.list;
            this.totalPage=response.data.data.pages;
            this.total=response.data.data.total;
					} else if(response.data.error==10000){
								this.$emit("getToken");
          } else {
						alert(response.data.msg);
					}
				})
      }

		}
	}
</script>

<style scoped="scoped">
	.exchange{
    width:100%;
    height:100%;
    font-size:0.3rem;
    text-align:center;
  }
  .exchangeHeader{
    background:url("../assets/img/exchangeBg.png")no-repeat;
    height:4.26rem;
    display:flex;
  }
  .exchangeHeader>div:nth-child(1){
    width:5.06rem;
    height:1.92rem;
    background:url("../assets/img/banner1.png")no-repeat;
    background-size:100% 100%;
    margin-left:0.4rem;
    margin-top:0.6rem;
    margin-right:0.6rem;
  }
  .exchangeHeader>div:nth-child(2){
    width:1.04rem;
    height:2.3rem;
    background:url("../assets/img/banner2.png")no-repeat;
    background-size:100% 100%;

  }
  .exchangeContent{
    width:6.75rem;
    height:6.36rem;
    background:linear-gradient(310deg,rgba(16,17,22,1) 0%,rgba(48,40,37,1) 100%);
    border-radius:12px;
    margin:-1.7rem auto 0 auto;
  }
  .exchangeContent>.contentHeader{
    font-size:0.32rem;
    font-family:SourceHanSansCN;
    font-weight:400;
    color:rgba(222,187,133,1);
    display:flex;
    justify-content: center;
    align-items:center;
    padding-top:0.66rem;
  }
  .contentHeader>div:nth-child(2){
    margin:0 0.2rem;
  }
  .contentHeader>div:nth-child(1),.contentHeader>div:nth-child(3){
    width:2.55rem;
    height:0.06rem;
    background:rgba(222,188,133,1);
  }
  .exchangeNum,.exchangePhone{
    width:5.98rem;
    height:1rem;
    border:0.01rem solid rgba(232,201,151,1);
    border-radius:0.28rem ;
    margin:0.4rem auto;
  }
  .exchangeNum input,.exchangePhone input{
    height:100%;
    width:100%;
    background-color:transparent;
    outline: none;
    border:none;
    font-size:0.28rem;
    font-family:SourceHanSansCN;
    font-weight:400;
    color:rgba(189,188,185,1);
    padding-left:0.35rem;
  }
  .exchangeButton{
    width:5.98rem;
    height:1.19rem;
    background:linear-gradient(225deg,rgba(211,172,113,1) 0%,rgba(234,204,154,1) 100%);
    border-radius:0.14rem;
    font-size:0.34rem;
    font-family:SourceHanSansCN;
    font-weight:400;
    color:rgba(20,20,24,1);
    line-height:1.19rem;
    margin:0 auto;
    
  }
  .exchangeRule{
    font-family:SourceHanSansCN;
    font-weight:400;
    color:rgba(96,96,96,1);
    text-align:left;
    margin: 0 auto;
    font-size:0.26rem;
    padding:0 0.5rem;
    margin-top:0.3rem;
  }
  .exchangeRule>span:nth-child(1){
    display:block;
    font-size:0.3rem;
  }
  .exchangeRule>div{
    margin-top:0.3rem;
  }
  .exchangeRule>div:last-child{
    margin-bottom:0.3rem;
  }
  .wmassageMask{
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: rgba(0,0,0,0.6);
      z-index: 101;
      transition:all 1s;
      display:flex;
      
  }
.messageMaskContent{
    position: absolute;
    left: 50%;
    top:50%;
    transform: translateX(-50%) translateY(-50%);
    background-color: #fff;
    background:linear-gradient(225deg,rgba(211,172,113,1) 0%,rgba(234,204,154,1) 100%);
    border-radius:0.46rem;
    width:7.02rem;
    padding-bottom:0.5rem;
}
.messageMaskContent {
    font-size:0.28rem;
    font-family:SourceHanSansCN;
    font-weight:400;
    color:rgba(96,96,96,1);
}
.msgHeader{
  font-size:0.3rem;
  font-family:SourceHanSansCN;
  font-weight:bold;
  color:rgba(96,96,96,1);
  position:relative;
  padding:0.38rem 0 0.52rem 0;
}
.msgHeader>i{
  display:inline-block;
  width:0.48rem;
  height:0.48rem;
  background:url("../assets/img/exchangeRemove.png")no-repeat;
  background-size:100% 100%;
  position:absolute;
  top:0.29rem;
  right:0.43rem;
}
.msgContent>div:nth-child(1){
  font-size:0.3rem;
  display:flex;
}
.msgContent>div:nth-child(1)>span{
  flex:1;
}
.msgContent>ul>li{
  display:flex;
  margin-top:0.2rem;
}
.msgContent>ul>li>span{
  flex:1;
}
.msgBottom{
  display:flex;
  justify-content: center;
  margin-top:0.4rem;
}
</style>


// WEBPACK FOOTER //
// src/components/exchange.vue